import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS, { QUERY_KEYS } from 'services/urls';
import { IMarket } from 'types/market';
import { trackDatadogRumError } from 'utils/initDatadogRum';

const getMarkets = async (): Promise<IMarket[]> => {
    const response = await axiosInstance.get<IMarket[]>(API_ENDPOINTS.MSAS);
    if (!Array.isArray(response.data)) {
        trackDatadogRumError(
            new Error('[useGetMarkets] Expected array response'),
            { receivedType: typeof response.data, receivedValue: response.data },
        );
        return [];
    }
    return response.data;
};

export const useGetMarkets = (options?: Omit<UseQueryOptions<IMarket[]>, 'queryKey' | 'queryFn'>) => useQuery<IMarket[], Error>({
    queryKey: [QUERY_KEYS.MSAS],
    queryFn: () => getMarkets(),
    staleTime: Infinity,
    ...(options ?? {}),
});
